<template>
  <b-row v-if="items.length > 0">
    <b-col>
      <b-table
        bordered
        class="agv-table"
        :items="items"
        :fields="fields"
        :is-busy="items == []"
        :tbody-tr-class="detailsClassFn"
      >
        <template #head(building_owner.lastname)>
          Participant
        </template>
        <template #head(representative)>
          Pouvoirs détenus
        </template>
        <template #head(logs)>
          Logs
        </template>
        <template v-slot:cell(building_owner.lastname)="row">
          <div>
            <appMandateName
              :mandate="row.item"
              :presence-mandates="presenceMandates"
              :is-video-case="true"
            />
          </div>
        </template>
        <template v-slot:cell(representative)="row">
          <div>
            <appMandateRepresentant
              :main-mandate="row.item"
              :presence-mandates="presenceMandates"
              :is-video-case="true"
            />
          </div>
        </template>
        <template v-slot:cell(logs)="row">
          <div>
            <appMandatePresenceLogs
              :main-mandate="row.item"
              :presence-mandates="presenceMandates"
              :is-video-case="true"
            />
          </div>
        </template>
      </b-table>
    </b-col>
  </b-row>
</template>

<script>
import meetingPresenceMixin from "@/mixins/meeting-presence";

export default {
  components: {
    appMandateName: () => import("@/components/b-table-components/MandateName"),
    appMandateRepresentant: () => import("@/components/b-table-components/MandateRepresentant"),
    appMandatePresenceLogs: () => import("@/components/b-table-components/MandatePresenceLogs"),
  },
  mixins: [meetingPresenceMixin],
  props: {
    presenceMandates: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {
      fields: [
        {
          key: "building_owner.lastname",
          sortable: true,
        },
        {
          key: "representative",
        },
        {
          key: "logs",
        },
      ],
    };
  },
  computed: {
    items() {
      var MandatesRepresentedByThemSelves = this.getPresentMandates(this.presenceMandates, "video");
      var MandatesRepresentedByContacts = this.getMandatesRepresentedByContacts(
        this.presenceMandates,
        "video"
      );
      var MandatesThatLeft = this.getMandatesThatLeft(this.presenceMandates, "video");

      var MandatesRepresentedByContactsNotPresentYet = this.getMandatesRepresentedByContactsNotPresentYet(
        this.presenceMandates,
        "video"
      );

      return [].concat(
        MandatesRepresentedByThemSelves,
        MandatesRepresentedByContacts,
        MandatesThatLeft,
        MandatesRepresentedByContactsNotPresentYet
      );
    },
  },
  methods: {
    detailsClassFn(item, rowType) {
      // item: the row's item data
      // rowType: a string describing the `<tr>` type
      if (item.$disabled) {
        // If it is a row-details row, add the the following classes
        // to the `<tr>` element
        // display none on xs and up, display table-row md and up
        return "bg-secondary";
      } else if (
        item.presence_status == this.mandatePresenceStatuses.pouvoir_by_video_not_present_yet
      ) {
        return "bg-orange-light";
      }
    },
  },
};
</script>
